// extracted by mini-css-extract-plugin
module.exports = {"button":"InventoryRowApplyButton_button__fjDPc","button-ltr":"InventoryRowApplyButton_button-ltr__1_bfZ"};